export const CATALOGUE_CONTENT_TYPE_BY_EXTENSION: Record<string, string> = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    pdf: 'application/pdf',
    mp4: 'video/mp4',
};

export const CATALOGUE_LINK_PREVIEW_LIMIT = 25;

export const CATALOGUE_DEFAULT_CONTENT_TYPE = 'image/jpeg';

export const CATALOGUE_MODAL_CONTENT_HEIGHT = 480;

export const CATALOGUE_SKELETON_COUNT = 6;

export const CATALOGUE_CONTENT_FADE_TIMEOUT = 400;
